import React from "react";
import { useNavigate } from "react-router-dom";
import { ErrorComponent, LoadingSpinner, PageLayout } from "shared";
import {
  ProgramDetailsCard,
  useProgram,
  HelpFlotingIcon,
  CourseListingText,
  emptyProgramText,
} from "..";
import ErrorImg from "assets/images/error-robot.png";

import bookIconBlue from "assets/images/icons/practical_prg.png";
import marathiLearningContentImage from "assets/images/icons/marathi_learning_content.png";
import theoryIcon from "assets/images/icons/Learning_Material.png";
import suitcaseIconPink from "assets/images/icons/Assignement.png";
import checklistIconBrown from "assets/images/icons/assessment.png";
import certificateIconGreen from "assets/images/icons/certificate.png";
import { getSelectedProgram } from "utils";
import { MwcdLogoComopent, useAppScope } from "master";

export const ProgramDetails = () => {
  const navigate = useNavigate();
  const selectedProgram = getSelectedProgram();
  const { isMWCD, lanSettings } = useAppScope();

  const { name, programDetails } = useProgram({ load: true });
  const { data } = programDetails;

  if (programDetails.isPending || programDetails.isLoading) {
    return <LoadingSpinner />;
  }

  const {
    hasTheory,
    hasLearningMaterials,
    hasAssignment,
    hasAssessment,
    hasCertificates,
    hasHelp,
    batchAssociatesLogoURL,
    programAssociatesLogoUrl,
    learningMaterialsProgress,
    totalAssignmentHour,
    completedAssignmentHour,
    totalAssessmentCount,
    completedAssessmentCount,
    totalCertificatesCount,
    completedCertificatesCount,
    scheduledAssessmentCount,
    courseTypeDetailsDTO,
    assignmentProgress,
  } = !!data && data;

  let learningDetails = courseTypeDetailsDTO?.find((e) => e.courseType === 1);
  let OJTDetails = courseTypeDetailsDTO?.find((e) => e.courseType === 2);
  let theoryDetails = courseTypeDetailsDTO?.find((e) => e.courseType === 0);

  const hasAnything =
    hasLearningMaterials ||
    hasAssignment ||
    hasAssessment ||
    hasCertificates ||
    hasTheory;

  const titleEndComponent = [
    <div key={programAssociatesLogoUrl} className="logo-group">
      {programAssociatesLogoUrl && (
        <img src={programAssociatesLogoUrl} alt="logo" />
      )}
      {batchAssociatesLogoURL && (
        <img src={batchAssociatesLogoURL} alt="logo" />
      )}
      {isMWCD && <MwcdLogoComopent customClass="logo-group-mwcd_PD" />}
    </div>,
  ];

  const goToPreviousPage = () => {
    navigate(-1, { replace: true });
  };

  const onProgramDetailsClick = (obj, status) => {
    const path =
      status === 2
        ? "assignment"
        : status === 1
          ? "practicals"
          : "learningmaterials";
    if (obj?.hasCourseGroup) {
      sessionStorage?.setItem("courseList", JSON.stringify(obj));
      navigate(`${path}/coursegroup`);
    } else {
      sessionStorage?.removeItem("courseGroup");
      sessionStorage?.setItem("courseList", JSON.stringify(obj));
      navigate(`${path}/courseslist`);
    }
  };

  return (
    <PageLayout
      title={hasAnything ? name : false}
      titleEndComponent={hasAnything || isMWCD ? titleEndComponent : false}
      breadcrumb={[{ label: name }]}
    >
      <div className="row featured-list">
        <div className="col-12 featured-content">
          {hasAnything ? (
            <>
              <div className="page-grid-items page-grid-items--box">
                {hasTheory && (
                  <ProgramDetailsCard
                    title={
                      theoryDetails?.displayName ||
                      `${CourseListingText.LearningMaterials[
                      lanSettings?.lan || "en"
                      ]
                      }`
                    }
                    theme={"rgba(237, 222, 250, 1)"}
                    icon={theoryIcon}
                    onClick={() => onProgramDetailsClick(theoryDetails, 0)}
                  />
                )}
                {hasLearningMaterials && (
                  <ProgramDetailsCard
                    title={
                      learningDetails?.displayName ||
                      `${CourseListingText.LearningContent[
                      lanSettings?.lan || "en"
                      ]
                      }`
                    }
                    theme={"#eaf2ff"}
                    progress={learningMaterialsProgress}
                    icon={isMWCD ? marathiLearningContentImage : bookIconBlue}
                    isFullWidthIcon={isMWCD}
                    onClick={() => onProgramDetailsClick(learningDetails, 1)}
                  />
                )}
                {hasAssignment && (
                  <ProgramDetailsCard
                    title={
                      OJTDetails?.displayName ||
                      `${CourseListingText.Assignment[lanSettings?.lan || "en"]
                      }`
                    }
                    theme={"#ffeafa"}
                    assignmentProgress={assignmentProgress}
                    totalAssignmentHour={totalAssignmentHour}
                    completedAssignmentHour={completedAssignmentHour}
                    icon={suitcaseIconPink}
                    onClick={() => onProgramDetailsClick(OJTDetails, 2)}
                    displayDuration={selectedProgram?.displayDuration}
                  />
                )}
                {hasAssessment && (
                  <ProgramDetailsCard
                    title={`${CourseListingText.Assessment[lanSettings?.lan || "en"]
                      }`}
                    theme={"#fdefe0"}
                    totalCount={totalAssessmentCount}
                    completedCount={completedAssessmentCount}
                    icon={checklistIconBrown}
                    isAssessment={true}
                    scheduledAssessmentCount={scheduledAssessmentCount}
                    onClick={() => navigate("assessment")}
                  />
                )}
                {hasCertificates && (
                  <ProgramDetailsCard
                    title={`${CourseListingText.Certification[lanSettings?.lan || "en"]
                      }`}
                    theme={"#e9fbf4"}
                    totalCount={totalCertificatesCount}
                    completedCount={completedCertificatesCount}
                    icon={certificateIconGreen}
                    onClick={() => navigate("certificate")}
                  />
                )}
              </div>
              <div key={titleEndComponent} className="page-bottom-logos">
                {titleEndComponent}
              </div>
            </>
          ) : (
            <ErrorComponent
              title={emptyProgramText.NoContent[lanSettings?.lan || "en"]}
              message={emptyProgramText.Message[lanSettings?.lan || "en"]}
              image={ErrorImg}
              btnLabel={emptyProgramText.GoBack[lanSettings?.lan || "en"]}
              onClick={goToPreviousPage}
            />
          )}
        </div>
      </div>
      {hasHelp && <HelpFlotingIcon />}
    </PageLayout>
  );
};
